// extracted by mini-css-extract-plugin
export var collapsedSummary = "_q1-0";